import React, { useEffect, useState } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { fetchDomesticPackages, fetchInternationalPackages, API_BASE_URL } from '../utils/api';

function TrendingDestinations() {
  const [destinations, setDestinations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        setIsLoading(true);
        const domestic = await fetchDomesticPackages({ type: 'category' });
        const international = await fetchInternationalPackages({ type: 'category' });

        // Pick only required destinations
        const selectedDomestic = domestic
          .filter((pkg) => ['Rajasthan', 'Goa', 'Gujarat'].includes(pkg.name))
          .map((d) => ({ ...d, type: 'domestic' }));

        const selectedInternational = international
          .filter((pkg) => ['Dubai', 'Thailand', 'Bali', 'Singapore'].includes(pkg.name))
          .map((d) => ({ ...d, type: 'international' }));

        const combined = [...selectedDomestic, ...selectedInternational];

        // Map images to full URL if coming from uploads folder
        const destinationsWithURL = combined.map((dest) => ({
          ...dest,
          image: dest.image.startsWith('http') ? dest.image : `${API_BASE_URL}/${dest.image}`, // prepend base URL
        }));

        // Fixed order
        const order = ['Dubai', 'Bali', 'Rajasthan', 'Thailand', 'Goa', 'Singapore', 'Gujarat'];

        const orderedDestinations = order
          .map((name) => destinationsWithURL.find((dest) => dest.name === name))
          .filter(Boolean);

        setDestinations(orderedDestinations);
      } catch (error) {
        console.error('Error fetching destinations:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDestinations();
  }, []);

  return (
    <div className='bg-[#EFFFF8] py-5 md:py-10'>
      {/* Header */}
      <div className='container mx-auto mt-4 px-4 md:mt-0 lg:px-16'>
        <div className='flex max-w-full items-center justify-between'>
          <p className='text-2xl font-medium leading-tight tracking-normal text-[#495BFF] md:text-[40px]'>
            Trending Destinations
          </p>
          <Link
            to='/service/holidays'
            className='group flex items-center gap-1 text-[16px] font-semibold text-[#495BFF] md:text-[20px]'
          >
            See all
            <FiArrowUpRight className='transform text-[24px] text-[#55E6A5] transition-transform duration-500 group-hover:rotate-45' />
          </Link>
        </div>

        {/* Destinations or Skeleton Loader */}
        <div className='mt-8 grid grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7'>
          {isLoading
            ? Array(7)
                .fill()
                .map((_, index) => (
                  <div
                    key={index}
                    className={`flex flex-col items-center ${
                      index === 6 ? 'col-span-2 justify-center sm:col-span-1 sm:justify-start' : ''
                    }`}
                  >
                    <div className='h-40 w-40 animate-pulse rounded-full bg-gray-200'></div>
                    <div className='mt-6 h-6 w-24 animate-pulse rounded bg-gray-200'></div>
                  </div>
                ))
            : destinations.map((dest, index) => (
                <div
                  key={index}
                  className={`flex flex-col items-center ${
                    index === destinations.length - 1
                      ? 'col-span-2 justify-center sm:col-span-1 sm:justify-start'
                      : ''
                  }`}
                >
                  {/* ✅ Clickable Link */}
                  <Link
                    to={`/${dest.type}/${dest.name.toLowerCase()}`}
                    className='group'
                  >
                    <div className='flex flex-col items-center'>
                      <div className='group h-40 w-40 overflow-hidden rounded-full'>
                        <img
                          src={dest.image}
                          alt={dest.description || dest.name}
                          className='h-40 w-40 rounded-full object-cover transition-transform duration-500 group-hover:scale-105'
                        />
                      </div>

                      <p className='mt-6 text-lg font-semibold text-[#495BFF] transition-colors duration-500 hover:text-[#55E6A5]'>
                        {dest.name}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
}

export default TrendingDestinations;
